import classNames from "classnames";
import Text from "../Text";
import { Img } from "components";

const AvatarCards = ({ icon: Icon, title, description, iconColor, image }) => {
    return (
        <div className="bg-[white] rounded-2xl p-4 shadow-sm hover:shadow-md transition-shadow duration-300 h-full">
            <div className="bg-gray-50 rounded-2xl mb-6 flex items-center justify-center max-h-[300px] overflow-hidden">
                <Img src={image} alt={title} imageClassName={classNames("object-cover",title === "AI Startups Assistant" ? "object-[-20px_120px]" : "object-[50%_80px] md:object-[50%_120px]")} />
            </div>

            <div className="flex items-center gap-3 mb-4">
                <Icon className={`w-6 h-6 ${iconColor}`} />
                <Text
                    type="cardTitle"
                    label={title}
                    cName="text-lg font-semibold text-[#181818]"
                />
            </div>
            <Text
                type="description"
                label={description}
            />
        </div>
    );
};

export default AvatarCards;